<app-wg-crud-table [title]="config.title" [fields]="config.fields" [service]="service"></app-wg-crud-table>
